import * as React from "react";
import Button from "@mui/material/Button";
// import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { Box } from "@mui/system";
import { Step, StepButton, Stepper } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import EditInfo from "./EditDataStoreComponent/EditInfo";
import EditInput from "./EditDataStoreComponent/EditInput";
import EditOutput from "./EditDataStoreComponent/EditOutput";
import EditSave from "./EditDataStoreComponent/EditSave";
import { useSelector } from "react-redux";
import {
  buildAndDispatchEdit,
  fetchBizLayerQuery,
  replaceCustomPlaceholdersEdit,
  // buildAndDispatchDbMetadata,
  validatePlaceholders,
} from "../DataStoreHelpers/dataStoreHelpers";
import {
  setDbMetadataPayload,
  setDbMetaDataPostFailed,
  setEditQueryFormData,
  setHasError,
  setIsLoading,
  setEditBizQueryPayload,
  setEditQueryFormDataInput,
  resetLocalMergedOutputData,
  setEditLoading,
} from "../../../../features/dataStoreReqSlice";
import { useDispatch } from "react-redux";
import { DataStoreReqEndPointLogic } from "../../../../logic/Admin/DataStoreRequest/DataStoreRequestEndPointLogic";
import { selectUserToken } from "../../../../features/userSlice";
// import { fetchBizLayerQuery } from "../DataStoreHelpers/dataStoreHelpers";
import EditOutputError from "./EditDataStoreComponent/EditOutPutError";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function EditDataStoreRequest() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); // Add this line
  const urlId = searchParams.get("id") as any;
  const token = useSelector(selectUserToken);
  const {
    hasError,
    editQueryFormData,
    editQueryFormDataInput,
    dbMetadataPayload,
    isLoadingButtonEdit,
    dbMetaDataPostFailed,
    editBizQueryPayload,
    editId,
    localMergedOutputData,
  } = useSelector((state: any) => state.dataStoreReq);

  const fetchQueryData = async () => {
    try {
      // dispatch(setEditLoading(true));
      await DataStoreReqEndPointLogic.getBizLayerQueryById(
        token,
        dispatch,
        setEditLoading,
        urlId, // use the parameter 'id' directly instead of `editId`
        navigate
      );
    } catch (error) {
      console.error("Error fetching query data:", error);
    } finally {
      dispatch(setEditLoading(false));
    }
  };

  React.useEffect(() => {
    if (urlId) {
      fetchQueryData();
    } else {
      dispatch(setEditLoading(false));
    }
    // eslint-disable-next-line
  }, [urlId]);

  const steps = ["Info", "Input", "Output", "Save"];

  const [activeStep, setActiveStep] = React.useState(0);
  const dispatch = useDispatch();
  const [completed, setCompleted] = React.useState<{ [k: number]: boolean }>(
    {}
  );
  const formData = useSelector(
    (state: any) => state.dataStoreReq.editQueryFormData
  );
  const oauthToken = useSelector(selectUserToken);
  const placeholders = validatePlaceholders(editQueryFormData.query);
  let react_env = import.meta.env.VITE_ENV;

  React.useEffect(() => {
    if (
      editQueryFormData?.query &&
      editQueryFormDataInput &&
      Object.keys(editQueryFormDataInput).length > 0
    ) {
      const replaced = replaceCustomPlaceholdersEdit(
        editQueryFormData.query,
        editQueryFormDataInput,
        react_env
      );

      dispatch(
        setDbMetadataPayload({
          database: editQueryFormData?.database,
          query: replaced.replace(/\s+/g, " ").trim(),
        })
      );
    }
  }, [
    editQueryFormData.query,
    editQueryFormDataInput,
    react_env,
    dispatch,
    editQueryFormData?.database,
  ]);

  React.useEffect(() => {
    if (activeStep === 3) {
      const payload = buildAndDispatchEdit(
        formData,
        placeholders,
        editQueryFormDataInput,
        localMergedOutputData
      );
      dispatch(setEditBizQueryPayload(payload));
    }

    // eslint-disable-next-line
  }, [activeStep]);

  const handleNext = async () => {
    if (activeStep === 0) {
      const result = validatePlaceholders(formData.query);
      if (!result.isValid) {
        dispatch(setHasError(true));
        return;
      }
      dispatch(setHasError(false)); // Clear any previous errors if validation passes
      setCompleted((prev) => ({ ...prev, [activeStep]: true })); // Mark step as completed
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 1) {
      const isSuccess = await DataStoreReqEndPointLogic.postMetaDataEdit(
        oauthToken,
        dbMetadataPayload,
        dispatch
      );
      if (isSuccess) {
        setCompleted((prev) => ({ ...prev, [activeStep]: true }));
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    } else if (activeStep === 2) {
      setCompleted((prev) => ({ ...prev, [activeStep]: true })); // Mark step as completed
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 3) {
      const isSuccessPost = await DataStoreReqEndPointLogic.putBizLayerQuery(
        oauthToken,
        editBizQueryPayload,
        dispatch,
        editId
      );
      if (isSuccessPost) {
        handleFinish();
      }
    }
  };

  const handleBack = () => {
    setCompleted((prev) => {
      const newCompleted = { ...prev };
      delete newCompleted[activeStep - 1]; // Remove checkmark from previous step
      return newCompleted;
    });
    setActiveStep((prevActiveStep) => Math.max(prevActiveStep - 1, 0)); // Prevent negative index
  };

  const handleStep = (step: number) => {
    setActiveStep(step);
  };
  const resetQueryFormState = () => {
    dispatch(setHasError(false));
    dispatch(
      setEditQueryFormData({
        name: "",
        database: null,
        description: "",
        query: "",
        modules: null,
        type: null,
        confluence_url: null,
      })
    );
    dispatch(setDbMetaDataPostFailed(false));
    dispatch(
      setEditQueryFormDataInput({
        __replace: true,
        data: {}, // reset all fields to an empty object
      })
    );
    dispatch(resetLocalMergedOutputData());
  };

  const handleFinish = () => {
    // Mark final step as completed and close dialog
    setCompleted((prev) => ({ ...prev, [activeStep]: true }));

    // Reset stepper after small delay

    setActiveStep(0);
    setCompleted({});

    // Reset all relevant state
    resetQueryFormState();
    fetchBizLayerQuery(oauthToken, dispatch, setIsLoading);
    setTimeout(() => {
      handleCancel();
    }, 0);
  };

  const isFormStep0Incomplete = Object.entries(editQueryFormData)
    .filter(([key]) => key !== "confluence_url")
    .some(([_, val]) => !val);

  const isFormStep1Incomplete = (() => {
    const input = editQueryFormDataInput;
    const requiredFields = [
      "title",
      "description",
      "format",
      "order",
      "value_for_test",
    ];
    const validFormats = ["string", "number", "date", "array"];

    if (!input || Object.keys(input).length === 0) return true;

    const grouped = Object.entries(input).reduce((acc: any, [key, value]) => {
      const [group, ...fieldParts] = key.split("-");
      const field = fieldParts.join("-");
      (acc[group] ??= {})[field] = value;
      return acc;
    }, {} as Record<string, Record<string, any>>);

    return Object.values(grouped).some((group: any) =>
      requiredFields.some((field) => {
        const val = group[field];

        if (field === "order") {
          return isNaN(val);
        }

        if (field === "format") {
          return typeof val !== "string" || !validFormats.includes(val.trim());
        }

        if (field === "value_for_test" && group["format"] === "array") {
          // Validate array format:
          return (
            !Array.isArray(val) ||
            val.some(
              (item: any) => typeof item !== "string" || item.trim() === ""
            )
          );
        }

        return typeof val !== "string" || val.trim() === "";
      })
    );
  })();

  const handleCancel = () => {
    resetQueryFormState(); // handles full reset including confluence_url and type
    setActiveStep(0); // Reset the stepper
    setCompleted({});
    const currentParams = new URLSearchParams(window.location.search);

    navigate({
      pathname: "/admin/datastore_requests",
      search: currentParams.toString(),
    });
  };

  React.useEffect(() => {
    DataStoreReqEndPointLogic.getBizLayerQueryModules(
      token,
      dispatch,
      setIsLoading
    );
    // eslint-disable-next-line
  }, []);

  return (
    <Box>
      <DialogTitle id="alert-dialog-title">
        {"Edit Request - " +
          (activeStep === steps.length - 1
            ? "Review and Save"
            : steps[activeStep] +
              (activeStep === 1 || activeStep === 2 ? " Fields" : ""))}
      </DialogTitle>
      <DialogContent
        sx={{
          overflow: "hidden", // Prevent scrollbars inside dialog
          paddingBottom: "10px", // Optional: if spacing is pushing height
        }}
      >
        <Box sx={{ width: "100%", overflow: "hidden" }}>
          <Stepper nonLinear activeStep={activeStep}>
            {steps.map((label, index) => {
              const isStepDisabled = index > 0 && !completed[index - 1]; // disable step if previous step not completed

              return (
                <Step key={label} completed={completed[index]}>
                  <StepButton
                    disabled={isStepDisabled}
                    onClick={() => handleStep(index)}
                    sx={{
                      "& .MuiStepIcon-root": {
                        color:
                          activeStep === index &&
                          (dbMetaDataPostFailed || hasError)
                            ? "rgba(211, 47, 47, 1) !important"
                            : activeStep === index || completed[index]
                            ? "rgba(156, 39, 176, 1) !important"
                            : "rgba(0, 0, 0, 0.38) !important",
                      },
                      "&.Mui-active .MuiStepIcon-root, &.Mui-completed .MuiStepIcon-root":
                        {
                          color:
                            label === "Save" && hasError
                              ? "rgba(211, 47, 47, 1) !important"
                              : "rgba(156, 39, 176, 1) !important",
                        },
                    }}
                  >
                    {label}
                  </StepButton>
                </Step>
              );
            })}
          </Stepper>
        </Box>

        {/* Conditional rendering based on active step */}
        {activeStep === 0 && <EditInfo />}

        {activeStep === 1 && (
          <Box>
            {!dbMetaDataPostFailed ? <EditInput /> : <EditOutputError />}
            {/*Please use this part for error */}
          </Box>
        )}

        {activeStep === 2 && (
          <Box>
            {/* will need to implement this after done */}
            <EditOutput />
          </Box>
        )}

        {activeStep === 3 && <EditSave />}
      </DialogContent>

      <DialogActions sx={{ padding: "24px 24px 24px 24px" }}>
        <Button
          onClick={handleCancel} // Function to close the dialog
          color="secondary"
        >
          Cancel
        </Button>
        <Button
          onClick={handleBack}
          variant="outlined"
          color="secondary"
          sx={activeStep === 0 ? { display: "none" } : {}}
          startIcon={<ArrowBackIcon />}
        >
          Back
        </Button>
        <Button
          disabled={
            (activeStep === 0 && isFormStep0Incomplete) ||
            (activeStep === 1 && isFormStep1Incomplete) ||
            isLoadingButtonEdit
          }
          onClick={handleNext}
          loading={isLoadingButtonEdit}
          color="secondary"
          variant="contained"
          endIcon={
            activeStep === steps.length - 1 ? (
              <SaveOutlinedIcon />
            ) : (
              <ArrowForwardOutlinedIcon />
            )
          }
          {...(activeStep === steps.length - 1
            ? { "data-tracker": "242" }
            : {})}
        >
          {activeStep === steps.length - 1
            ? "SAVE CHANGES TO DATASTORE"
            : "Next"}
        </Button>
      </DialogActions>
    </Box>
  );
}
